/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectItemCostQueryResult } from '../../models/get-project-item-cost-query-result';

export interface ApiProjectItemGetProjectItemCostGet$Plain$Params {
  Id: string;
}

export function apiProjectItemGetProjectItemCostGet$Plain(http: HttpClient, rootUrl: string, params: ApiProjectItemGetProjectItemCostGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemCostQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemGetProjectItemCostGet$Plain.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectItemCostQueryResult>;
    })
  );
}

apiProjectItemGetProjectItemCostGet$Plain.PATH = '/api/ProjectItem/GetProjectItemCost';
